import React, { useState, useEffect } from 'react';
import FormGroup from 'components/FormGroup';
import { useLazyQuery, useMutation } from "@apollo/client";
import { useFormik } from 'formik';
import _mapValues from 'lodash/mapValues'

export default function useForm({
  fieldsForm,
  // schema of fields validation
  schema,
  // dont use the default submit handler
  onSubmit,
  loadQuery,
  // name of query in order to pull the data
  loadQueryReply,
}) {

  const [fieldState, setFieldState] = useState({ ...fieldsForm })

  const formik = useFormik({
    initialValues: _mapValues(fieldState, 'value'),
    validationSchema: schema,
    enableReinitialize: true,
    onSubmit: onSubmit
  });

  const renderElementsForm = () => {
    const formElementsArr = []
    if (fieldState) {
      for (let key in fieldState) {
        formElementsArr.push({
          id: key,
          config: fieldState[key]
        })
      }
    }
    return formElementsArr
  }


  const renderElement = (formElement, labels, children) => {
    let Element = (
      <FormGroup
        config={formElement.config.controlConfig}
        key={formElement.id}
        name={formElement.id}
        label={labels && labels[formElement.id]}
        elementType={formElement.config.elementType}
        controlId={formElement.config.controlId}
        value={formik.values[formElement.id]}
        changed={formik.handleChange}
        children={children}
        errorMessage={formik.errors[formElement.id]}
        aria-label={labels[formElement.id]}
        aria-describedby={labels[formElement.id]}
        className={formElement.config?.className}
      />
    )
    return Element;
  }

  const handleLoadData = data => {

    const loadForm = { ...fieldState }
    if (data) {
      for (let formElement in fieldState) {
        loadForm[formElement] = {
          ...fieldState[formElement],
          value: (data[formElement] || data[formElement] === false) ? data[formElement] : loadForm[formElement].value,
        }
      }
    }
    setFieldState(loadForm)
  }

  return { formik, renderElementsForm, renderElement, handleLoadData }

}